import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'

import { Permission } from '@/lib/permissions'
import { isUseCase } from '@/lib/utils'

import { SearchSchema } from '../index'

export const Route = createFileRoute('/_dashboard/air-quality/map/$floorId/')({
  validateSearch: SearchSchema,
  beforeLoad({ context }) {
    if (!isUseCase(UseCase.AIR_QUALITY)) {
      throw redirect({ to: '/403', search: { reason: 'wrongUseCase' } })
    }

    if (!context.user?.hasPermission(Permission.EDIT_FLOOR_PLAN)) {
      throw redirect({ to: '/403' })
    }
  },
})
